<nav class="main-header navbar navbar-expand-lg">
  <div class="container">
    <a class="navbar-brand pt-3 pb-3 pr-3" href="#">
      <img [src]="brand.logoPath" width="126px" height="40" [attr.alt]="brand.logoAlt" />
    </a>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link main-link" href="#">Employer Quick Quote Tool</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
